// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2zRnQ","errors":"Errors_errors__3tniP"};